export default {
  label: {
    merchantId: 'số doanh nghiệp',
    channelName: 'Tên kênh',
    api: 'tên API',
    status: 'tình trạng',
    action: 'vận hành',
    attribute3: 'Tên người vận hành',
    attribute4: 'xác suất',
    merchantName: 'Tên doanh nghiệp'
  },
  status: {
    open: 'bật',
    close: 'Khép kín'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/vi/channelList.js